export default {
  'form-toast-errors-title': 'O formulário teve os seguintes erros:',
  'form-toast-error-title': 'O formulário teve o seguinte erro:',
  'required': ': deve ser preenchido',
  'unique': ': já foi utilizado',
  'integer': ': deve ser um número inteiro',
  'number': ': deve ser um número com duas casas decimais',
  'email': ': deve ser um e-mail válido',
  'requireLastName':  ': o sobrenome deve ser preenchido junto com o nome',
  'cnpjValidations':  ': é inválido',
  'cpfValidations':  ': é inválido',
  'requiredWithoutAny': ': o campo deve ser obrigatório quando todos os outros campos tiverem valores vazios',

  'button-go-back': 'Voltar',
  'button-menu-actions': 'Ações',
  'button-menu-edit': 'EDITAR',
  'button-menu-delete': 'EXCLUIR',
  'button-menu-import-file': 'IMPORTAR',
  'button-menu-new': 'NOVO',
  'form-toast-success': 'Registro salvo com sucesso',
  'sendNotification': 'Enviar Notificação',

};
